/*
 * 6tm-cart-group.js
 * --------------------------------------------------------------
 * Delete d'items du panier via le bouton .cart-item-trash.
 *
 * Pattern natif Baseline reutilise (voir assets/cart-items.js lignes
 * 187-249 pour la version originale, single item via CartItemQuantity) :
 *   POST /cart/change avec body {id, quantity: 0, sections, sections_url}
 *   -> dispatch baseline:cart:cartqtychange sur document.body
 *   -> Baseline morph le drawer + count + footer via CartItems.onCartQuantityChange
 *
 * Pour un item unique : 1 seul POST.
 * Pour un groupe typo (data-cart-remove="k1,k2,k3") : boucle sequentielle
 * en awaiting each response pour eviter des race conditions.
 *
 * Ecoute en CAPTURE PHASE sur document pour attraper l'event AVANT qu'un
 * quelconque handler Alpine ancetre (drawer teleport, close on outside,
 * etc.) puisse stopPropagation. Symptome observe sinon : le click sur
 * .cart-item-trash n'atteignait jamais le handler en bubbling normal.
 * -------------------------------------------------------------- */
(function () {
  'use strict';
  console.log('[6tm-cart-group] script loaded, readyState=', document.readyState);

  var CART_SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function parseKeys(csv) {
    if (!csv) return [];
    return csv.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function changeOne(key) {
    /* Reproduction stricte du call natif Baseline :
       assets/cart-items.js ligne 201-208. */
    return fetch('/cart/change', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
        sections: CART_SECTIONS,
        sections_url: window.location.pathname
      })
    }).then(function (resp) {
      if (!resp.ok) throw new Error('cart change failed: ' + resp.status);
      return resp.json();
    });
  }

  function dispatchBaselineChange(data, key) {
    /* Meme structure de detail que le natif : cart-items.js ligne 237-249. */
    try {
      document.body.dispatchEvent(new CustomEvent('baseline:cart:cartqtychange', {
        bubbles: true,
        detail: {
          response: data,
          key: key,
          quantity: 0,
          previousQuantity: 1,
          variantId: null,
          originalTarget: null
        }
      }));
    } catch (e) { /* noop */ }
  }

  function removeAll(btnEl, keys) {
    if (!keys.length) return;

    /* Fade visuel du parent (groupe ou li unitaire). */
    var container = btnEl.closest('[data-6tm-group]') || btnEl.closest('li');
    if (container) {
      container.style.opacity = '0.4';
      container.style.pointerEvents = 'none';
    }

    /* Sequential pour eviter les race conditions cote Shopify cart. */
    var chain = Promise.resolve();
    keys.forEach(function (k) {
      chain = chain.then(function () {
        return changeOne(k).then(function (data) {
          dispatchBaselineChange(data, k);
          return data;
        });
      });
    });

    chain.catch(function (err) {
      /* eslint-disable no-console */
      console.error('[6tm-cart-group] remove failed', err);
      window.location.reload();
    });
  }

  /* Capture phase : le handler fire AVANT tout enfant qui aurait stopPropagation.
     Necessaire parce que le drawer est teleporte via Alpine x-teleport et
     un handler ancetre semble consommer le click en phase bubbling. */
  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
    if (!target) return;
    console.log('[6tm-cart-group] click captured (capture phase)', target, 'keys=', target.getAttribute('data-cart-remove'));
    e.preventDefault();
    e.stopPropagation();
    var keys = parseKeys(target.getAttribute('data-cart-remove') || '');
    removeAll(target, keys);
  }, true);

  console.log('[6tm-cart-group] click delegation attached (capture phase)');
})();
